<template>
  <v-card>
    <v-card-title>
      <h2 class="card-title">{{ $t('base.add_mixer') }}</h2>
    </v-card-title>
    <v-card-content>
      <v-text-field :focus="true" :label="$t('base.mixer_name')" :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')" v-model="form.name" />
    </v-card-content>
    <v-card-actions>
      <v-btn @click="onCreate" :loading="loading">
        {{ $t('base.add') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import formErrorsMixin from '@/mixins/form-errors.mixin.js'

export default {
  name: 'AddMixerModal',

  data: () => ({
    form: {
      name: null
    },
    errors: {
      name: null
    },
    loading: false
  }),

  mixins: [formErrorsMixin],

  methods: {
    async onCreate () {
      this.loading = true

      this.checkValidData()

      if (this.errors.name === null) {
        const mixerData = {
          name: this.form.name
        }
        this.$emit('update', mixerData)
        this.$emit('close')
      }

      this.loading = false
    },

    checkValidData () {
      this.errors.name = null

      if (!this.form.name) {
        this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = ['6', 100]
      }
    }
  }
}
</script>